import {
  HttpResponse,
  TableRelatedDocumentsSearchDto,
} from '@asset-metrix/portal-gateway-client-js';
import { triggerDownloadWithAnchorTag } from '@asset-metrix/portal-ui';

import { getContentDispositionFileName } from '../../utils/contentDisposition';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const datatableDownloadDocumentWithSignedUrl = async ({
  defaultFileName,
  documentId,
  isRelatedDocument = false,
  query,
  selection,
  widgetId,
}: {
  defaultFileName?: string;
  documentId: string;
  isRelatedDocument?: boolean;
  query?: {
    inline?: boolean;
    parentDocumentId?: string;
    token?: string;
  };
  selection?: TableRelatedDocumentsSearchDto['selection'];
  widgetId: string;
}) => {
  const downloadUrlResponse = await (isRelatedDocument
    ? portalGatewayClient.table.getRelatedDocumentDownloadUrl(
        widgetId,
        documentId,
        { selection: selection ?? {} },
        query
      )
    : portalGatewayClient.table.getDocumentDownloadUrl(
        documentId,
        widgetId,
        query
      ));

  if (!downloadUrlResponse.ok) {
    throw new HttpError('Error downloading document', downloadUrlResponse);
  }

  const { url: downloadUrl } = downloadUrlResponse.data.data;

  const downloadResponse = await fetch(downloadUrl);

  if (!downloadResponse.ok) {
    throw new HttpError(
      'Error downloading document',
      downloadResponse as HttpResponse<unknown, unknown>
    );
  }

  // force the browser to treat it as a downloadable file rather than trying to display it inline.
  const blob = new Blob([await downloadResponse.arrayBuffer()], {
    type: 'application/octet-stream',
  });

  const blobUrl = URL.createObjectURL(blob);

  const contentDisposition = downloadResponse.headers.get(
    'content-disposition'
  );

  const fileName =
    (contentDisposition && getContentDispositionFileName(contentDisposition)) ??
    defaultFileName;

  triggerDownloadWithAnchorTag(blobUrl, fileName);
};
